/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_EDITCLIP,EDITCLIP_RECEIVED , CLEAR_EDITCLIP} = constants.EditClipConstant;

export default {
    REQUEST_EDITCLIP,
    EDITCLIP_RECEIVED,
    CLEAR_EDITCLIP,

  requestEditClip: payload => ({
    type: REQUEST_EDITCLIP,
    payload
  }),
  EditClipReceived: () => ({
    type: EDITCLIP_RECEIVED
  }),
};
